import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue';
import Home from "@/pages/Home.vue";
import thongkebenhnhan from "@/pages/Thongkebenhnhan.vue";
import thongkedoanhthu from "@/pages/Thongkedoanhthu.vue";
import infoPage from "@/pages/InfoPage.vue";
import infoRealTimePage from "@/pages/InfoRealTimePage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/thongkebenhnhan',
    name: 'thongkebenhnhan',
    component: thongkebenhnhan,
    props: true
  },
  {
    path: '/thongkedoanhthu',
    name: 'thongkedoanhthu',
    component: thongkedoanhthu,
    props: true
  },
  {
    path: '/',
    name: 'thongtin',
    component: infoPage,
    props: true
  },
  {
    path: '/thongtintructuyen',
    name: 'thongtintructuyen',
    component: infoRealTimePage,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
